import { XpoAuthenticationGuard } from '@xpo/ngx-auth';
import { XpoLtlAuthGuard } from '@xpo-ltl/ngx-auth';

/**
 * SSO + Firebase login guards applied to every authenticated route.
 * Single source of truth — spread into a route's `canActivate` alongside any
 * route-specific guards, e.g. `canActivate: [...AUTH_GUARDS, MaintAdminsGuard]`.
 */
export const AUTH_GUARDS = [XpoAuthenticationGuard, XpoLtlAuthGuard];
